import { getPublicLang } from 'academy-common-lib/utils/url';
import { socialLinks } from './footerLinks';
import styled, { mediaQuery, css, theme } from 'academy-common-lib/utils/Styling';
import UIIcon from 'UIComponents/icon/UIIcon';
import { appendHubsContent } from '../../../../utils/urls';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SocialLinksList = styled(UIList).withConfig({
  displayName: "SocialLinks__SocialLinksList",
  componentId: "fwwpnh-0"
})(["display:flex;justify-content:center;gap:5px;margin:24px 0 32px;", " & .social-name{display:none;}& a{display:inline-block;padding:8px;", "}"], mediaQuery('notTablet', css(["justify-content:flex-end;"])), mediaQuery('notTablet', css(["padding:3px;"])));
const SocialLinks = () => {
  return /*#__PURE__*/_jsx(SocialLinksList, {
    children: socialLinks.map(link => {
      const linkHref = link.hrefs[getPublicLang()] || link.hrefs.en;
      if (!linkHref) return null;
      return /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs("a", {
          href: appendHubsContent(linkHref, link.name),
          rel: "noopener noreferrer",
          target: "_blank",
          title: link.name,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            color: theme.colors.FLINT,
            name: link.icon,
            size: 24
          }), /*#__PURE__*/_jsx("span", {
            className: "social-name",
            children: link.name
          })]
        })
      }, link.name);
    })
  });
};
export default SocialLinks;